import PageLayout from "@/components/PageLayout";
import SEO from "@/components/SEO";

const Terms = () => {
  return (
    <PageLayout>
      <SEO title="Terms of Service" description="Terms of service for FractionalCPO." path="/terms" />
      <div className="max-w-3xl mx-auto px-6 py-24">
        <h1 className="text-4xl font-light mb-12">Terms of Service</h1>
        <div className="space-y-6 text-muted-foreground leading-relaxed">
          <p><strong className="text-foreground">Effective Date:</strong> February 15, 2026</p>

          <p>By accessing FractionalCPO.com ("the Site"), you agree to the following terms.</p>

          <h2 className="text-xl text-foreground pt-4">Services</h2>
          <p>FractionalCPO.com provides fractional Chief Product Officer services to growth-stage and PE-backed technology companies. Specific service terms are governed by individual client agreements.</p>

          <h2 className="text-xl text-foreground pt-4">Intellectual Property</h2>
          <p>All content on this website — including text, graphics, and logos — is the property of FractionalCPO.com and may not be reproduced without written permission.</p>

          <h2 className="text-xl text-foreground pt-4">Limitation of Liability</h2>
          <p>The Site and its content are provided "as is." We make no warranties regarding the accuracy or completeness of the information provided and are not liable for any damages arising from your use of the Site.</p>

          <h2 className="text-xl text-foreground pt-4">Governing Law</h2>
          <p>These terms are governed by the laws of the Province of Ontario, Canada.</p>

          <h2 className="text-xl text-foreground pt-4">Contact</h2>
          <p>Questions about these terms can be directed to <a href="mailto:hi@fractionalcpo.com" className="text-foreground underline">hi@fractionalcpo.com</a>.</p>
        </div>
      </div>
    </PageLayout>
  );
};

export default Terms;
